import { render, staticRenderFns } from "./englishlogin.vue?vue&type=template&id=38b2c802&scoped=true&"
import script from "./englishlogin.vue?vue&type=script&lang=js&"
export * from "./englishlogin.vue?vue&type=script&lang=js&"
import style0 from "./englishlogin.vue?vue&type=style&index=0&id=38b2c802&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2c802",
  null
  
)

export default component.exports